const BUTTON_NAME_SHOW = "Mehr anzeigen";
const BUTTON_NAME_HIDE = "Weniger anzeigen";
const showMoreLessButton: HTMLElement = document.querySelector(".showMoreLess");
const moreLessBox: HTMLElement = document.querySelector(".moreLessBox");

function ShowMoreLessText(this: HTMLElement): void {

	if (showMoreLessButton.textContent === BUTTON_NAME_SHOW) {
		showMoreLessButton.textContent = BUTTON_NAME_HIDE;
		moreLessBox.classList.add('show');
	} else {
		showMoreLessButton.textContent = BUTTON_NAME_SHOW;
		moreLessBox.classList.remove('show');
		moreLessBox.classList.add('hide');

		moreLessBox.scrollTop = 0;
	};
}

function ShowMoreButton(): void {
/**
* Event wenn Prduktdetailstext zu lang ist
*/
	if (moreLessBox && moreLessBox.offsetHeight < 340) {
		showMoreLessButton.hidden = true;
	}
}

export const ShowMoreText = (): void => {
	ShowMoreButton();
	showMoreLessButton.addEventListener("click", ShowMoreLessText);
};
